import usePage from 'hooks/usePage';
import useStore from 'hooks/useStore';
import useTheme from 'hooks/useTheme';
import { isEmpty } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import EventItem from './EventItem';

const EventsSidebar = () => {
  const { state } = useStore();
  const { eventsOnSidebar } = state;
  const { isRemoxTheme } = useTheme();

  const { isDashboardPage, isFxDashboardPage } = usePage();

  if (isRemoxTheme) return null;
  if (isEmpty(eventsOnSidebar)) return null;
  if (isDashboardPage || isFxDashboardPage)
    return (
      <EventsSidebarWrap>
        {eventsOnSidebar?.map((e, index) => (
          <EventItem key={index} item={e} />
        ))}
      </EventsSidebarWrap>
    );
  return null;
};

const EventsSidebarWrap = styled.div`
  position: absolute;
  bottom: 164px;
  display: grid;
  gap: 12px;
  width: calc(100% - 48px);
`;

export default EventsSidebar;
